export function getImageData(canvas: HTMLCanvasElement): ImageData {
    return canvas.getContext("2d", { willReadFrequently: true })!.getImageData(0, 0, canvas.width, canvas.height);
}

export function copyCanvas(from: HTMLCanvasElement, to: HTMLCanvasElement) {
    to.getContext("2d", { willReadFrequently: true })!.drawImage(from, 0, 0);
}
